/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Organize_1Inputs */

const en_pc_tut_organize_1 = /** @type {(inputs: Pc_Tut_Organize_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Organize pages from All tools or with ⌘K.`)
};

const zh_pc_tut_organize_1 = /** @type {(inputs: Pc_Tut_Organize_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从「All tools」或用 ⌘K 打开「Organize pages」。`)
};

/**
* | output |
* | --- |
* | "Open Organize pages from All tools or with ⌘K." |
*
* @param {Pc_Tut_Organize_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_organize_1 = /** @type {((inputs?: Pc_Tut_Organize_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Organize_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_organize_1(inputs)
	return zh_pc_tut_organize_1(inputs)
});
export { pc_tut_organize_1 as "pc.tut.organize.1" }